import instance from "./instance";

export default {
  
  getMms: (params) =>
    instance({
      url: "/mms",
      method: "get",
      params:params
    }),
    getZss: (params) =>
      instance({
        url: "/zss",
        method: "get",
        params:params
      }),
  getCatlist: (params) =>
      instance({
        url: "/dynamics",
        method: "get",
        params:params
      }),
      geKeylist: (params) =>
        instance({
          url: "/home/search",
          method: "get",
          params:params
        }),
      getStandard: (params) =>
        instance({
          url: "/standard",
          method: "get",
          params:params
        }),
        getStandardDetail: (params) =>
          instance({
            url: "standard/details",
            method: "get",
            params:params
          }),
      getDetail: (params) =>
        instance({
          url: "dynamics/details",
          method: "get",
          params:params
        }),

        getInfoDetail: (params) =>
          instance({
            url: "/Intro",
            method: "get",
            params:params
          }),
  playList: ({cat = "全部", limit = 50, pageNo = 1}) => {
    let offset = (pageNo - 1) * limit;
    return instance({
      url: "/top/playlist",
      method: "post",
      params: {
        order: "hot",
        cat,
        limit,
        offset,
      },
    });
  },
  // 获取歌单详细
  playlistDetail: (id) =>
      instance.get(`/playlist/detail?id=${id}&s=8`),
}